export default "__VITE_ASSET__b56078db__"